import { IntegrationAgentNames } from '@constants';
import { Tenant } from 'TenantModule/types';
import { putApiGalaxyServer } from 'services';
import { Realm } from 'types';

export interface AddServiceToRealmPayload {
  realmId: Realm['realm_id'];
  requestingService: IntegrationAgentNames;
  tenant: Tenant['tenantName'];
  isFirstRealm?: boolean;
  adminDatabaseCredentialSecret?: string;
}

export type AddServiceToRealmSuccessResponse = Record<string, never>;

export interface AddServiceToRealmErrorResponse {
  error: string;
  message: string;
  statusCode: number;
}

export const addServiceToRealm = ({
  params: data,
  token,
  config = {},
}: BaseApiParams<AddServiceToRealmPayload>) =>
  putApiGalaxyServer(`/realm/addServiceToRealm`, data, config, token);
